import OrderSummaryCards from "./OrderSummaryCards";
import CustomRow from "../../../components/Row";
import ArrowLeftOutlined from "@ant-design/icons/lib/icons/ArrowLeftOutlined";
import { useAuth } from "../../../context/AuthContext";
import { getUserStatisticSummaryUseCase } from "../../../../applications/useCase/ApiUseCase/UserApiUseCase";
import usePageState from "../../../hooks/usePageState";
import { useState } from "react";
import { UserStatisticSummary } from "../../../../infrastructure/model/AppUserModel";
import useAsyncEffect from "../../../hooks/useAsyncEffect";

interface Props {
  setActiveMenuNav: (val: number) => void;
}
function ListOrder(props: Props) {
  const { setActiveMenuNav } = props;
  const { setLoading, showError } = usePageState();
  const { authData } = useAuth();
  const [summaryState, setSummaryState] = useState<UserStatisticSummary>();

  async function getUserStatisticSummary() {
    if (!authData?.id) return;
    const res = await getUserStatisticSummaryUseCase({
      userId: authData.id,
      setLoading,
      showError,
    });
    if (res) {
      setSummaryState(res);
    }
  }

  useAsyncEffect(async () => {
    await getUserStatisticSummary();
  }, []);

  return (
    <div style={{ padding: 16 }}>
      <CustomRow>
        <div
          onClick={() => setActiveMenuNav(1)}
          style={{
            cursor: "pointer",
            color: "#1677ff",
            marginBottom: 16,
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
          }}
        >
          <ArrowLeftOutlined />
          Quay lại trang chủ
        </div>
      </CustomRow>
      <OrderSummaryCards summary={summaryState} />

      <div style={{ marginTop: 24 }}>
        {/* {orders.map((order) => (
          <OrderCard key={order.id} order={order} />
        ))} */}
      </div>
    </div>
  );
}
export default ListOrder;
